import styled from "styled-components";

export const BannerWrap = styled.div`
  display: flex;
  height: var(--banner-h, 90px);
  justify-content: center;
  background: linear-gradient(
    97.81deg,
    #00438b 0%,
    #07c93e 0.01%,
    #1da945 13.54%,
    #20a446 15.63%,
    #3c7b4e 32.81%,
    #00438b 58.85%,
    rgba(0, 67, 139, 0.76) 94.27%
  );
`;
export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(25px, 1.6vw, 60px);
  h2 {
    font-size: clamp(36px, 2.25vw, 86px);
    line-height: 1.5;
    font-family: "Saira Semi Condensed", sans-serif;
    font-weight: 600;
    color: white;
  }
  img {
    max-width: clamp(50px, 3.1vw, 120px);
    height: auto;
  }
  @media screen and (max-width: 1023px) {
    padding-left: 12px;
    padding-right: 12px;
    h2 {
      font-size: 28px;
      line-height: 32px;
    }
  }

  /* Phones: title on the left, logo on the right. */
  @media screen and (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    padding-left: 20px;
    padding-right: 20px;
    h2 {
      font-size: 26px;
    }
  }
`;